import { z } from 'zod'

/**
 * Common string validation patterns
 */
export const commonStringSchemas = {
  required: (field: string) => z.string().min(1, `${field} is required`),
  optional: () => z.string().optional(),
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
  uuid: z.string().uuid('Invalid UUID format'),
  nonEmptyString: z.string().min(1, 'String cannot be empty'),
}

/**
 * Common number validation patterns
 */
export const commonNumberSchemas = {
  positive: z.number().positive('Must be a positive number'),
  nonNegative: z.number().min(0, 'Must be a non-negative number'),
  integer: z.number().int('Must be an integer'),
  positiveInteger: z.number().int().positive('Must be a positive integer'),
}

/**
 * Common date validation patterns
 */
export const commonDateSchemas = {
  date: z.date(),
  dateString: z.string().datetime('Invalid date format'),
  isoDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format'),
}

/**
 * Common array validation patterns
 */
export const commonArraySchemas = {
  nonEmpty: <T>(schema: z.ZodType<T>) => z.array(schema).min(1, 'Array cannot be empty'),
  optional: <T>(schema: z.ZodType<T>) => z.array(schema).optional(),
}

/**
 * Common validation error messages
 */
export const validationMessages = {
  required: (field: string) => `${field} is required`,
  invalid: (field: string) => `Invalid ${field}`,
  tooShort: (field: string, min: number) => `${field} must be at least ${min} characters`,
  tooLong: (field: string, max: number) => `${field} must be no more than ${max} characters`,
  notFound: (field: string) => `${field} not found`,
  alreadyExists: (field: string) => `${field} already exists`,
} as const
